module.exports = __webpack_public_path__ + "static/jci-vector-84c780634be23855e022e62ef83a5291.gif";